export default "__VITE_ASSET__BcdU4kgD__"